{
    "aanpassen": "pencil",
    "actie": "tag",
    "actief": "active",
    "afval": "trash",
    "afval1": "trash-alt",
    "align-2": "align-justify",
    "behandeling": "treatment",
    "bel": "bell",
    "bericht": "message",
    "beveiliging": "shield",
    "bijlage": "attachment",
    "boek": "book",
    "boven": "arrow-up",
    "cadeau": "gift",
    "check-cirkel": "check-circle",
    "dalen": "decrease",
    "delen": "share",
    "diep": "anchor",
    "edit1": "edit",
    "elektrisch": "electric",
    "extreem": "extreme",
    "fotos": "camera",
    "gebruiker": "user",
    "gebruiker1": "user",
    "gebruikers": "users",
    "geen-fotos": "no-camera",
    "geluid": "sound",
    "genezend": "healing",
    "geur": "scent",
    "gezen": "healing",
    "gezondheid": "heart",
    "handdoek": "towel",
    "herhaling": "repeat",
    "herkomst": "flag",
    "hotel": "moon",
    "kaart": "map",
    "kaart1": "card",
    "kalender": "calendar",
    "klok": "clock",
    "kopen": "shopping-bag-low",
    "kruis": "cross",
    "lagen": "layers",
    "lijst": "clipboard",
    "linker": "arrow-left",
    "links-boven": "arrow-left-up",
    "links-onder": "arrow-left-down",
    "links-rond": "arrow-circle-left",
    "locatie": "location",
    "menu1": "menu",
    "negatief": "thumbs-down",
    "nevel": "cloud-light-rain",
    "next": "chevron-right",
    "ok": "check",
    "onder-rond": "arrow-circle-down",
    "onder": "arrow-down",
    "opladen": "charge",
    "opties": "grid",
    "percentage1": "percentage",
    "plus-leeg": "plus-circle",
    "plus1": "plus",
    "positief": "thumbs-up",
    "prev": "chevron-left",
    "rechter": "arrow-right",
    "rechts-boven": "arrow-right-up",
    "rechts-onder": "arrow-right-down",
    "rechts-rond": "arrow-circle-right",
    "richting": "compas",
    "shopping-bag-line": "shopping-bag-high",
    "shopping-bag": "shopping-bag-high",
    "speciaal": "star-outline",
    "stel": "male-female",
    "stijgen": "increase",
    "telefoon": "phone",
    "televisie": "tv",
    "trash-2": "trash-alt",
    "twitter": "x",
    "up-rond": "arrow-circle-up",
    "verstuur": "send",
    "video-off": "no-video",
    "visueel": "eye",
    "vochtig": "water-drop",
    "vrouw": "woman",
    "warmte": "sun",
    "wifi1": "wifi",
    "winkelmand": "shopping-cart",
    "zoeken": "search",
    "zoom-uit": "zoom-out"
}
